import { useQuery } from '@tanstack/react-query';
import { api } from '../../services/api.js';
import { useMapStore } from '../../stores/mapStore.js';
import { useUiStore } from '../../stores/uiStore.js';
import { Button, LoadingSpinner } from '../ui/index.js';
import { DayCard } from './DayCard.js';
import type { Day } from '../../types/index.js';

export function DayPlanner() {
  const { activeProject } = useMapStore();
  const { openModal } = useUiStore();

  const { data, isLoading } = useQuery({
    queryKey: ['days', activeProject?.id],
    queryFn: async () => {
      if (!activeProject) return [];
      const result = await api.get<{ days: Day[] }>(`/days?projectId=${activeProject.id}`);
      return result.success ? result.data.days : [];
    },
    enabled: !!activeProject,
  });

  if (!activeProject) {
    return (
      <div className="text-center py-8 text-gray-400 text-sm">
        <p className="text-3xl mb-2">📅</p>
        <p>Select a project to plan days</p>
      </div>
    );
  }

  const days = data ?? [];

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <h2 className="text-xs font-semibold uppercase tracking-wider text-gray-400">Shoot Days</h2>
        <Button size="sm" variant="ghost" onClick={() => openModal('dayForm', { projectId: activeProject.id })}>+ Day</Button>
      </div>

      {isLoading ? (
        <div className="flex justify-center py-4"><LoadingSpinner size="sm" /></div>
      ) : days.length === 0 ? (
        <div className="text-center py-6 text-gray-400 text-sm">
          <p>No shoot days yet</p>
          <button onClick={() => openModal('dayForm', { projectId: activeProject.id })} className="mt-1 text-brand-500 hover:text-brand-600 text-sm">Plan first day</button>
        </div>
      ) : (
        <div className="space-y-2">
          {days.map(d => <DayCard key={d.id} day={d} />)}
        </div>
      )}
    </div>
  );
}
